import { h, Fragment } from "preact";
import { RevisionSelect } from "../../../components/RevisionSelect";
import { Label, ProductTypeRevision } from "../../../api/product-api";
import { useEffect, useState } from "preact/hooks";
import { useRevisions } from "../../../hooks/useRevisions";
import { LabelSelect } from "../../../components/LabelSelect";
import { LabelPrint } from "../../../components/LabelPrint";

export function StellaBIOFlashPrint({ onPrint, serialNumber }: { serialNumber: string; onPrint: () => void }) {
    const { manufacturingConfiguration, revisions, currentRevision } = useRevisions("StellaBIO");

    const [selectedLabel, setSelectedLabel] = useState(null as null | Label);
    const [selectedRevision, setSelectedRevision] = useState(null as ProductTypeRevision | null);

    useEffect(() => {
        if (currentRevision) {
            setSelectedRevision(currentRevision);
        }
    }, [currentRevision]);

    if (!manufacturingConfiguration) {
        return <div class="loader" />;
    }

    return (
        <>
            <h3 class="text-md font-bold">Rewizja</h3>
            <RevisionSelect
                currentRevision={manufacturingConfiguration.productType.currentProductTypeRevision}
                revisions={revisions}
                selected={selectedRevision}
                onChange={v => {
                    setSelectedRevision(v);
                    setSelectedLabel(null);
                }}
            />
            <div class="mt-4">
                <h3 class="text-md font-bold">Naklejka</h3>
                {selectedRevision && (
                    <LabelSelect
                        autoSelect
                        revision={selectedRevision}
                        selected={selectedLabel}
                        onChange={setSelectedLabel}
                    />
                )}
            </div>
            <div class="mt-4">
                {selectedLabel && (
                    <LabelPrint
                        serialNumber={serialNumber}
                        label={selectedLabel}
                        copies={1}
                        onPrint={onPrint}
                        noAutoCut={true}
                        productTypeRevision={selectedRevision ?? undefined}
                    />
                )}
            </div>
            {/* <input type="checkbox" class="popup-visible" id="popup-visible-controller-label" />
            <div class="popup">
                <label class="background" for="popup-visible-controller-label"></label>
                <div
                    class="content"
                    style="display: flex; flex-direction: column; padding: 10px; width: 800px; height: 800px;"
                >
                    <label
                        for="popup-visible-controller-label"
                        class="button icon flat"
                        style="align-self: flex-end;"
                    >
                        close
                    </label>
                    <div style="flex: 1 1 0; margin-top: 10px; align-self: center;">
                        <ImageSlider
                            width={700}
                            height={700}
                            images={[
                                resolvePath("images/labeling/stella-3.jpg"),
                                resolvePath("images/labeling/stella-2.jpg"),
                                resolvePath("images/labeling/stella-1.jpg"),
                            ]}
                        />
                    </div>
                </div>
            </div>
            <label class="button secondary" for="popup-visible-controller-label">
                Informacje o naklejaniu
            </label> */}
        </>
    );
}
